import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['serviceType', 'status'])}` : '';
  const searchZoneUnit = `searchZoneUnit(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchZoneUnit} {
        id
        name
        description
        createdDate
        serviceType
        zoneType
        status
      }
    }
  `;
};
